import api from './client';

export interface OnboardingStep {
  id: string;
  title: string;
  description: string;
  completed: boolean;
  completedAt?: string | null;
  skippable?: boolean;
}

export interface OnboardingStatus {
  completed: boolean;
  skipped: boolean;
  currentStep: number;
  steps: OnboardingStep[];
}

export const getOnboardingStatus = async (): Promise<OnboardingStatus> => {
  const res = await api.get('/api/v1/onboarding/status');
  return res.data;
};

export const completeStep = async (stepId: string, data?: any): Promise<{ success: boolean; status: OnboardingStatus }> => {
  const res = await api.post(`/api/v1/onboarding/steps/${stepId}/complete`, { data });
  return res.data;
};

export const skipOnboarding = async (): Promise<void> => {
  await api.post('/api/v1/onboarding/skip');
};

export const getChecklist = async (): Promise<{
  steps: OnboardingStep[];
  completedCount: number;
  totalCount: number;
}> => {
  const res = await api.get('/api/v1/onboarding/checklist');
  return res.data;
};
